import { useSelector } from "react-redux";
import { Layout } from "antd";

import { RootState } from "../../store/store";
import CustomMenu from "./menu/Menu";
import Logo from "../layout/Logo";
import { resourceTypeEnum } from "../../types/resourceType";

const HeaderComponent = () => {
  const { Header } = Layout;
  const reportState = useSelector((state: RootState) => state.report);
  const menuState = useSelector((state: RootState) => state.menu);
  const resourcesState = useSelector((state: RootState) => state.resources);

  return (
    <Header
      style={{
        padding: 0,
        minHeight: "4vh",
        height: "20px",
        lineHeight: menuState.menu.fullScreen ? "18px" : "18px",
        backgroundColor:
          resourcesState.resourceSelected?.type === resourceTypeEnum.REPORT
            ? reportState.report.config?.showHeader
              ? "#fff"
              : "#0050b3"
            : "#0050b3", //datasets case
      }}
    >
      {reportState.report.config?.showHeader ? <></> : <Logo />}
      <CustomMenu />
    </Header>
  );
};
export default HeaderComponent;
